import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Component } from 'vue-property-decorator';
import { MessageType } from '@gig/magic-sdk/dist/adapter/messages/message';
import { isHidden } from '../../util/messages.js';
import { MESSAGING_LOADED, MESSAGING_LIST } from '@gig/magic-messages';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let MessagesComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.messages = [];
    this.isLoading = false;
  }
  created() {
    this.messageSubscription = window.eventBus.subscribe(MESSAGING_LOADED, (event) => __async(this, null, function* () {
      this.isLoading = !event.payload;
      if (this.isLoading) {
        this.messages = [];
        return;
      }
      this.messages = yield window.queryBus.query(MESSAGING_LIST);
    }), { replay: true });
  }
  destroyed() {
    var _a;
    (_a = this.messageSubscription) == null ? void 0 : _a.unsubscribe();
  }
  get message() {
    return this.messages.find(({ id }) => id === this.messageId);
  }
  get filteredMessages() {
    return this.messages.filter((message) => message.type !== MessageType.NOTIFICATION && !isHidden(message));
  }
};
__decorateClass([
  Prop(String)
], MessagesComponent.prototype, "messageId", 2);
MessagesComponent = __decorateClass([
  Component({
    name: "messages"
  })
], MessagesComponent);

export default MessagesComponent;
